const c = {
  "cdr-chip": "cdr-chip_15-6-1-beta-4",
  "cdr-chip__icon-left": "cdr-chip__icon-left_15-6-1-beta-4",
  "cdr-chip__icon-right": "cdr-chip__icon-right_15-6-1-beta-4",
  "cdr-chip__content": "cdr-chip__content_15-6-1-beta-4"
};
export {
  c as default
};
